import { render, staticRenderFns } from "./area-code.vue?vue&type=template&id=5a8b2130&scoped=true"
import script from "./area-code.vue?vue&type=script&lang=js"
export * from "./area-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b2130",
  null
  
)

export default component.exports